import { Injectable } from '@angular/core';

declare const $: any;

@Injectable({ providedIn: 'root' })
export class ModalService {
    private lastFocusedEl: HTMLElement | null = null;

    open(id: string) {
        const el = document.getElementById(id);
        if (!el) return;

        this.lastFocusedEl = document.activeElement as HTMLElement | null;

        // When modal closes, restore focus (prevents the aria-hidden warning)
        $(el).one('hidden.bs.modal', () => {
            setTimeout(() => this.lastFocusedEl?.focus(), 0);
        });

        // Show modal (Bootstrap 4)
        $(el).modal({
            backdrop: false,
            keyboard: true,
            focus: true,
            show: true,
        });

        // Optional: force focus into modal
        setTimeout(() => $(el).trigger('focus'), 0);
    }

    close(id: string) {
        const el = document.getElementById(id);
        if (!el) return;

        // Blur active element before hiding (helps with aria-hidden + focused element)
        (document.activeElement as HTMLElement | null)?.blur();

        $(el).modal('hide');
    }
}
